import React from "react";
import styled, { css } from "styled-components";
import Field from "views/components/Field";
import Value from "views/components/Value";
import FieldType from "views/logic/fieldtypes/FieldType";
import { FULL_MESSAGE_FIELD } from "views/Constants";
import DecoratedValue from "./decoration/DecoratedValue";
import InteractiveContext from "../contexts/InteractiveContext";
const SPECIAL_FIELDS = [FULL_MESSAGE_FIELD, "level"];
const DecoratedField = styled.small(
  ({ theme }) => css`
    color: ${theme.colors.gray[70]};
    font-weight: normal;
  `
);
const DefinitionDescription = styled.dd(
  ({ theme }) => `
  font-family: ${theme.fonts.family.monospace};
`
);
export const MessageFieldName = ({ fieldName, fieldType, message }) => {
  var _a, _b, _c, _d;
  const isDecoratedField = ((_b = (_a = message == null ? void 0 : message.decoration_stats) == null ? void 0 : _a.added_fields) == null ? void 0 : _b[fieldName]) || ((_d = (_c = message == null ? void 0 : message.decoration_stats) == null ? void 0 : _c.changed_fields) == null ? void 0 : _d[fieldName]);
  return /* @__PURE__ */ React.createElement(Field, { name: fieldName, type: isDecoratedField ? FieldType.Decorated : fieldType }, fieldName);
};
const ValueContext = ({
  isDecoratedField,
  children = null
}) => {
  if (isDecoratedField)
    return /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: "disabled" }, children, " ", /* @__PURE__ */ React.createElement(DecoratedField, null, "(decorated)"));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export const MessageFieldValue = ({ message, fieldName, fieldType, value }) => {
  var _a, _b, _c, _d;
  const isDecoratedField = ((_b = (_a = message == null ? void 0 : message.decoration_stats) == null ? void 0 : _a.added_fields) == null ? void 0 : _b[fieldName]) || ((_d = (_c = message == null ? void 0 : message.decoration_stats) == null ? void 0 : _c.changed_fields) == null ? void 0 : _d[fieldName]);
  const innerValue = SPECIAL_FIELDS.indexOf(fieldName) !== -1 ? message.fields[fieldName] : value;
  return /* @__PURE__ */ React.createElement(ValueContext, { isDecoratedField }, /* @__PURE__ */ React.createElement(
    Value,
    {
      field: fieldName,
      value: innerValue,
      type: isDecoratedField ? FieldType.Decorated : fieldType,
      render: DecoratedValue
    }
  ));
};
const MessageField = ({ fieldName, fieldType, message, value }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", { "data-testid": `message-field-name-${fieldName}` }, /* @__PURE__ */ React.createElement(MessageFieldName, { message, fieldName, fieldType })), /* @__PURE__ */ React.createElement(DefinitionDescription, { "data-testid": `message-field-value-${fieldName}` }, /* @__PURE__ */ React.createElement(MessageFieldValue, { value, fieldName, fieldType, message })));
export default MessageField;
